import React from "react";
const icon = (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.01567 35C6.34857 34.9935 4.91412 34.5892 3.71227 33.7868C2.51687 32.9844 1.59611 31.8222 0.949946 30.3002C0.310264 28.7782 -0.00635743 26.9473 9.67014e-05 24.8077C9.67014e-05 22.6743 0.319945 20.8561 0.959643 19.3532C1.6058 17.8503 2.52657 16.7072 3.72197 15.924C4.92382 15.1343 6.35504 14.7395 8.01567 14.7395C9.67626 14.7395 11.1044 15.1343 12.2997 15.924C13.5015 16.7136 14.4255 17.8599 15.0717 19.3628C15.7178 20.8593 16.0378 22.6743 16.0312 24.8077C16.0312 26.9538 15.7081 28.7877 15.0619 30.3097C14.4223 31.8317 13.5048 32.9939 12.3093 33.7963C11.114 34.5987 9.68268 35 8.01567 35ZM8.01567 31.5707C9.15286 31.5707 10.0608 31.007 10.7393 29.8799C11.4178 28.7527 11.7536 27.062 11.7472 24.8077C11.7472 23.3238 11.5921 22.0884 11.2819 21.1013C10.9783 20.1142 10.5453 19.3723 9.98323 18.8756C9.42757 18.3789 8.77172 18.1305 8.01567 18.1305C6.88489 18.1305 5.98027 18.6877 5.30182 19.8022C4.62334 20.9166 4.28089 22.5851 4.27442 24.8077C4.27442 26.3106 4.42627 27.565 4.72997 28.5712C5.04012 29.5711 5.47627 30.3225 6.03842 30.8255C6.60057 31.3222 7.25967 31.5707 8.01567 31.5707ZM26.8067 35C25.1395 34.9935 23.7052 34.5892 22.5033 33.7868C21.3078 32.9844 20.3871 31.8222 19.741 30.3002C19.1012 28.7782 18.7846 26.9473 18.791 24.8077C18.791 22.6743 19.111 20.8561 19.7507 19.3532C20.3969 17.8503 21.3176 16.7072 22.5129 15.924C23.7148 15.1343 25.1461 14.7395 26.8067 14.7395C28.4673 14.7395 29.8954 15.1343 31.0907 15.924C32.2925 16.7136 33.2165 17.8599 33.8627 19.3628C34.5088 20.8593 34.8288 22.6743 34.8222 24.8077C34.8222 26.9538 34.4992 28.7877 33.8529 30.3097C33.2133 31.8317 32.2958 32.9939 31.1005 33.7963C29.905 34.5987 28.4737 35 26.8067 35ZM26.8067 31.5707C27.9439 31.5707 28.8518 31.007 29.5303 29.8799C30.2088 28.7527 30.5446 27.062 30.5382 24.8077C30.5382 23.3238 30.3831 22.0884 30.0729 21.1013C29.7693 20.1142 29.3363 19.3723 28.7742 18.8756C28.2186 18.3789 27.5627 18.1305 26.8067 18.1305C25.6759 18.1305 24.7712 18.6877 24.0927 19.8022C23.4144 20.9166 23.072 22.5851 23.0654 24.8077C23.0654 26.3106 23.2173 27.565 23.521 28.5712C23.8312 29.5711 24.2673 30.3225 24.8295 30.8255C25.3916 31.3222 26.0507 31.5707 26.8067 31.5707Z"
      fill="url(#paint0_linear_1468_37)"
    />
    <path
      d="M37.1559 14C37.1559 16.2484 39.0975 18.114 41.4374 18.114H45.7186C48.0585 18.114 50 16.2484 50 14H37.1559ZM37.1559 22.228V26.3421H44.6065C43.2493 28.3373 41.8114 31.2048 41.546 34.5701H45.8189C46.2942 30.1146 49.6404 26.7 50 26.3421V22.228H37.1559Z"
      fill="url(#paint1_linear_1468_37)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1468_37"
        x1="3.59013e-07"
        y1="25"
        x2="50"
        y2="25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A306E4" />
        <stop offset="1" stopColor="#8502E9" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1468_37"
        x1="3.59013e-07"
        y1="25"
        x2="50"
        y2="25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A306E4" />
        <stop offset="1" stopColor="#8502E9" />
      </linearGradient>
    </defs>
  </svg>
);

export default icon;
